import { Dispatch, Middleware } from "redux";
import _ from "underscore";

import getFloorNumber from "../getters/floor_getters/get_floor_number";
import getProjectName from "../getters/project_getters/get_project_name";
import RoutingEvent, { isRoutingEvent } from "../routing_events";
import { FLOOR_LOADED } from "../../events/loaded/floors/floor_loaded";

import type { ReduxStore } from "../reducers/root_reducer";

function getFloorNumberFromEvent(event: RoutingEvent, state: ReduxStore): string | null {
  if (event.payload?.floorNumber) {
    return event.payload.floorNumber;
  } else if (event.payload?.floorId) {
    return getFloorNumber(state, { floorId: event.payload.floorId });
  }
}

function getProjectNameFromEvent(event: RoutingEvent, state: ReduxStore): string | null {
  if (event.payload?.projectName) {
    return event.payload.projectName;
  } else {
    const projectId = event.payload?.projectId || event.payload?.firebaseProjectId || event.payload?.floor?.firebaseProjectId;
    return getProjectName(state, { projectId });
  }
}


const pageTitleMiddleware: Middleware<object, ReduxStore> = store => (next: Dispatch) => event => {
  if (isRoutingEvent(event)) {
    const state = store.getState();
    const projectName = getProjectNameFromEvent(event, state);

    const floorNumber = getFloorNumberFromEvent(event, state);
    const additionalInfo = _.omit({
      floorNumber,
      projectName,
    }, (info) => !info);
    return next({ ...event, payload: { ...event.payload, ...additionalInfo } });
  } else if (event.type === FLOOR_LOADED) {
    const state = store.getState();
    event.payload.projectName = getProjectNameFromEvent(event, state);
    return next(event);
  } else {
    return next(event);
  }
};

export default pageTitleMiddleware;
